export default __webpack_public_path__ + "static/media/1ee4c5e0e783f4bbab39a7857f9127c7.svg";